export default __webpack_public_path__ + "static/media/noMoreSchedule.b22ec758.svg";